import { BANK_STATEMENT } from './bank_statement.ts';
import { BILL_OF_LADING } from './bill_of_lading.ts';
import { GENERIC } from './generic.ts';
import { HEALTH_INSURANCE_CLAIM_FORM } from './health_insurance_claim_form.ts';
import { ID_CARD } from './id_card.ts';
import { INVOICE } from './invoice.ts';
import { NDA } from './nda.ts';
import { PAYSLIP } from './payslip.ts';
import { PURCHASE_ORDER } from './purchase_order.ts';
import { RECEIPT } from './receipt.ts';
import { RESUME } from './resume.ts';
import { W9_TAX_FORM } from './w9_tax_form.ts';

export const DEFAULT_TEMPLATE = 'Custom';

export const TEMPLATES = {
  Invoices: INVOICE,
  Receipts: RECEIPT,
  'Purchase Orders': PURCHASE_ORDER,
  'Bills of Lading': BILL_OF_LADING,
  'Bank Statements': BANK_STATEMENT,
  'ID Cards': ID_CARD,
  Payslips: PAYSLIP,
  Resumes: RESUME,
  NDAs: NDA,
  'W9 Tax Forms': W9_TAX_FORM,
  'Insurance Claims': HEALTH_INSURANCE_CLAIM_FORM,
  [DEFAULT_TEMPLATE]: GENERIC,
} as const;

export * from './common';
